export const backingInformationKeys = {
    stretchPay: 'stretch-pay',
    stablePledge: 'stable-pledge',
    crowdfundingRisks: 'crowdfunding-risks',
};